module.exports = __webpack_public_path__ + "img/carousel-2.212c8553.jpg";